/**
 * Gets a string representation of the regex that can be used to initialize a new regex.
 *
 * Note: This is useful if you need to use the regexes as strings for, e.g., JSON to ship to a client.
 *
 * @param {RegExp} regExp - an instance of a RegExp
 */
const stringify = regExp => {
  if (typeof regExp === 'string' && regExp !== '') {
    return regExp; // leave it as is, in case a regexp was specified as string
  }

  const isProbablyRegExp = (typeof regExp.exec === 'function' && typeof regExp.compile === 'function');

  if (!isProbablyRegExp) {
    throw new Error('Passed value is not a RegEx.');
  }

  let stringRegex = regExp.toString();
  stringRegex = stringRegex.substring(1, stringRegex.length - 1); // trim off the leading and ending slash, so the value can be used to create a new regex
  return stringRegex;
}

const Validation = {
  Password: /(?=.*[a-z])((?=.*\d)|(?=.*[!"#$%&'()*+,\-./:;<=>?@\[\\\]^_`{|}~]))(?!.*[ \t\n\f\r]).{8,100}/,
  EmailAddress: /^(?:[a-zA-Z0-9_\-\.]+)(?:\+[a-zA-Z0-9_\-\.]+)?@(?:([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z][-a-zA-Z0-9]{1,63}|[0-9]{1,3})$/,
  PhoneNumber: /^[+\d.+ ,()-*#]+$/, // intentionally loose--just ensure not using completely invalid characters
  Countries: {
    // See https://stackoverflow.com/a/7185241/2535090 for more on postal codes
    US: {
      PostalCode: /^\d{5}([ \-]\d{4})?$/, // 5-digit required, plus 4 optional
    },
    Canada: {
      PostalCode: /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ ]?\d[ABCEGHJ-NPRSTV-Z]\d$/,
    },
    China: {
      PostalCode: /^\d{6}$/
    }
  }
};


module.exports = {
  Validation,
  stringify
}

